import { Styles, css, cva } from '@flipster/styled-system/css';
import { square } from '@flipster/styled-system/patterns';

import FlipsterWhiteLogomark from './images/logomark.svg';
import FlipsterWhiteLogotype from './images/logotype.svg';

const logo = cva({
  variants: {
    color: {
      white: { color: 'content.default.level-5' },
      blue: { color: 'background.accent.primary' },
      black: { color: 'content.default.level-0' },
    },
  },
});

interface FlipsterLogoProps {
  withType?: boolean;
  color?: 'white' | 'blue' | 'black';
  css?: Styles;
}
export const FlipsterLogo = ({ withType, color = 'white', css: cssProps }: FlipsterLogoProps) => {
  const Logo = {
    logotype: FlipsterWhiteLogotype,
    logomark: FlipsterWhiteLogomark,
  }[withType ? 'logotype' : 'logomark'];
  return <Logo height={undefined} className={css(logo.raw({ color }), cssProps)} />;
};

const icon = cva({
  base: {},
  variants: {
    size: {
      small: { width: 72, height: 72, p: 16 },
      medium: { width: 96, height: 96, p: 22 },
    },
    type: {
      square: {},
      rounded: { rounded: 16 },
      circle: { rounded: 999 },
    },
    color: {
      white: { bg: 'content.default.level-5', color: 'content.default.level-0' },
      blue: { bg: 'background.accent.primary', color: 'content.default.level-5' },
      black: { bg: 'content.default.level-0', color: 'content.default.level-5' },
    },
  },
});

interface FlipsterIconProps {
  type: 'square' | 'rounded' | 'circle';
  color?: 'white' | 'blue' | 'black';
  size: 'small' | 'medium';
  css?: Styles;
}
export const FlipsterIcon = ({ type, color = 'white', size, css: cssProps }: FlipsterIconProps) => {
  return (
    <div className={css(square.raw(), icon.raw({ type, color, size }), cssProps)}>
      <FlipsterWhiteLogomark height={undefined} className={css({ w: 52 })} />
    </div>
  );
};
